import { tertiaryHoverSx } from '../../styles/Global.style';

export const listItemTileSx = (theme) => ({
  backgroundColor: theme.palette.background.secondary,
  margin: '8px 0',
  ...tertiaryHoverSx(theme),
});

export const listItemTextSx = (theme) => ({
  color: theme.palette.secondary.main,
});
